import { Fragment } from 'react';
import EventsByTimeOfDay from '../../../components/dashboard/events/EventsByTimeOfDay';
import EventsByGroupCard from '../../../components/dashboard/events/EventsByGroupCard';
import EventsByStoreCard from '../../../components/dashboard/events/EventsByStore';
import EventsCard from '../../../components/dashboard/events/EventsCard';
export default function EventsAnalytics() {

    return (
        <Fragment>
            <EventsCard />
            <EventsByTimeOfDay />
            <EventsByGroupCard />
            <EventsByStoreCard />
        </Fragment>
    )
}